import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { RootState } from "../../../app/store";
import axiosInstance from "../../../configs/axios/axios ";
import { USER_EDIT_PASSWORD } from "../../../configs/axios/constantsAPI";
import { getCookie } from "../../../configs/cookie-helper/cookieHelper";


export const editPasswordAction = createAsyncThunk(
  "editPassword/editeditPassword",
  async (sendData: any, { rejectWithValue, getState }: any) => {
    let token = getCookie("token") as string;
    try {
      const { data } = await axiosInstance.post(
        USER_EDIT_PASSWORD,
        JSON.stringify(sendData),
        {
          headers: {
            token: token ? token : getState().authenticationState.token,
          },
        }
      );
      return data;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }
      return rejectWithValue(error.response.data);
    }
  }
);

export interface editPasswordState {
  actionStatus: string;
  alert: {
    error: boolean;
    message: string;
  };
}

const initialState: editPasswordState = {
  actionStatus: "",
  alert: {
    error: false,
    message: "",
  },
};

export const editPasswordSlice = createSlice({
  name: "editPassword",
  initialState,
  reducers: {
    resetEditPasswordAction: (state) => {
      state.actionStatus = initialState.actionStatus;
      state.alert = initialState.alert;
    },
  },
  extraReducers: ({ addCase }) => {
    addCase(editPasswordAction.pending, (state) => {
      state.actionStatus = "loading";
      state.alert = {
        error: false,
        message: "",
      };
    });
    addCase(editPasswordAction.fulfilled, (state, { payload }) => {
      state.actionStatus = "success";
      state.alert = {
        error: payload.content?.error,
        message: payload.content?.error
          ? payload.content?.message === "login_again"
            ? "login_again"
            : payload.content?.message
          : "Great, we didn't encounter any errors!",
      };
    });
    addCase(editPasswordAction.rejected, (state, { payload }: any) => {
      state.actionStatus = "rejected";
      state.alert = {
        error: payload.content?.error,
        message: payload.content?.error
          ? "Sorry, we encountered an error!"
          : "Great, we didn't encounter any errors!",
      };
    });
  },
});

export const { resetEditPasswordAction } = editPasswordSlice.actions;

export const editPassword = (state: RootState) => state.editPasswordState;

export default editPasswordSlice.reducer;
